import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '../Constants/queryKeys';
import {
  GetDetailedOrganizationRegistrations,
  GetOrganizationRegistrations,
  GetUserOrganizations,
} from '../helper/apiHelper';

export const useUserOrganizations = (userId: number | undefined) => {
  return useQuery({
    queryKey: [...QUERY_KEYS.ORGANIZATIONS, userId],
    queryFn: () => {
      if (!userId) return null;
      return GetUserOrganizations(userId.toString());
    },
    enabled: !!userId,
  });
};

export const useUserOrganizationsIds = (userId: number | undefined) => {
  return useQuery({
    queryKey: [...QUERY_KEYS.ORGANIZATIONS, userId],
    queryFn: () => {
      if (!userId) return null;
      return GetUserOrganizations(userId.toString());
    },
    enabled: !!userId,
    select: (organizations) => {
      return organizations?.map((o) => o.id);
    },
  });
};

export const useAllRegistrations = () => {
  return useQuery({
    queryKey: [...QUERY_KEYS.ORGANIZATION_REGISTRATIONS],
    queryFn: GetOrganizationRegistrations,
  });
};

export const useDetailedOrganizationRegistrations = () => {
  return useQuery({
    queryKey: [...QUERY_KEYS.DETAILED_ORGANIZATION_REGISTRATIONS],
    queryFn: GetDetailedOrganizationRegistrations,
  });
};
